import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {
     DocumentGeneralDataTypeEnum, IMetadataItemDto,
    OrganizationDataTypeEnum,
    PersonDataTypeEnum
} from "../../../pages/settings/documentfields/metadata-item.dto";

export interface IAdvanceFilterComponent<T> {
    item: IAdvanceFilter<T>;
    filterValue: string | string[] | Date | Date [] | number | number[] | boolean;
    operator?: AdvancedFilterOperatorEnum;
    field_type:AdvancedFilterFieldTypesEnum;
    popover: NgbPopover;

    setUpForm?(): void;
}

export interface IAdvanceFilter<T> {
    uuid: string;
    value?: string | string[] | Date | Date [] | number | number[] | boolean;
    field_type: AdvancedFilterFieldTypesEnum,
    operator?: AdvancedFilterOperatorEnum;
    condition_type?: "and" | "or";
    text: string,
    isApplied: boolean;
    isOpened: boolean
    item: T;
    icon?:string;
}

export enum AdvancedFilterFieldTypesEnum {
    person_field = 'person_field',
    condition = "condition",
    document_field = 'document_field',
    organization_field='organization_field',
    general_field ='general_field'
}

export interface IMetadataAdvancedFilters {
    value?: string | string[] | Date | Date [] | number | number[] | boolean;
    operator?: AdvancedFilterOperatorEnum;
    field_type: AdvancedFilterFieldTypesEnum,
    meta_data_id: number,
}

export interface IConditionAdvancedFilter {
    field_type: AdvancedFilterFieldTypesEnum.condition,
    condition_type: AdvancedFilterOperatorEnum.or | AdvancedFilterOperatorEnum.and;

}

export interface IPersonDataAdvancedFilter {
    field_type: AdvancedFilterFieldTypesEnum.person_field,
    person_data_type: PersonDataTypeEnum
    value:string;
    operator:string
}

export interface IOrganizationDataAdvancedFilter {
    field_type: AdvancedFilterFieldTypesEnum.organization_field,
    organization_data_type: OrganizationDataTypeEnum,
    value:string;
    operator:string
}

export interface IGeneralDataAdvancedFilter {
    field_type: AdvancedFilterFieldTypesEnum.general_field,
    general_data_type: DocumentGeneralDataTypeEnum
    value:string;
    operator:string
}

export type AdvanceFilterParamType = IMetadataItemDto | IMetadataAdvancedFilters | IConditionAdvancedFilter | IPersonDataAdvancedFilter | IOrganizationDataAdvancedFilter | IGeneralDataAdvancedFilter;

export interface IAdvancedFilterListItem<T> {
    group: string,
    text: string,
    icon: string,
    field_type: AdvancedFilterFieldTypesEnum
    source: T
}

export enum AdvancedFilterOperatorEnum {
    eq = 'eq',
    ne = 'ne',
    gt = 'gt',
    gte = 'gte',
    lt = 'lt',
    lte = 'lte',
    between = 'between',
    or = 'or',
    and = 'and',
    startsWith = 'startsWith',
    contains = 'contains',
    endsWith = 'endsWith',
}

type IOperatorTranslations = {
    [key in AdvancedFilterOperatorEnum]: string;
};

export const AdvancedFiltersOperatorTranslations: IOperatorTranslations = {
    [AdvancedFilterOperatorEnum.eq]: "Advanced filter Equals operators (Advanced filters) - Equals",
    [AdvancedFilterOperatorEnum.ne]: "Advanced filter Not Equals operators (Advanced filters) - Not Equals",
    [AdvancedFilterOperatorEnum.gt]: "Advanced filter Greater then operators (Advanced filters) - Greater then",
    [AdvancedFilterOperatorEnum.gte]: "Advanced filter Greater or equal then operators (Advanced filters) - Greater then or equal",
    [AdvancedFilterOperatorEnum.lt]: "Advanced filter Less operators (Advanced filters) - Less then",
    [AdvancedFilterOperatorEnum.lte]: "Advanced filter Less or equal operators (Advanced filters) - Less then or equal",
    [AdvancedFilterOperatorEnum.between]: "Advanced filter Between operators (Advanced filters) - Between",
    [AdvancedFilterOperatorEnum.or]: "Advanced filter Or operators (Advanced filters) - Or",
    [AdvancedFilterOperatorEnum.and]: "Advanced filter And operators (Advanced filters) - And",
    [AdvancedFilterOperatorEnum.startsWith]: "Advanced filter Start with operators (Advanced filters) - Start with",
    [AdvancedFilterOperatorEnum.contains]: "Advanced filter Contains operators (Advanced filters) - Contains",
    [AdvancedFilterOperatorEnum.endsWith]: "Advanced filter End with operators (Advanced filters) - End with",
}